import { render, staticRenderFns } from "./FolderGrid.vue?vue&type=template&id=48e2a93a&scoped=true"
import script from "./FolderGrid.vue?vue&type=script&lang=ts"
export * from "./FolderGrid.vue?vue&type=script&lang=ts"
import style0 from "./FolderGrid.vue?vue&type=style&index=0&id=48e2a93a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e2a93a",
  null
  
)

export default component.exports